import { render, staticRenderFns } from "./visorpdf.vue?vue&type=template&id=0c272520&"
import script from "./visorpdf.vue?vue&type=script&lang=js&"
export * from "./visorpdf.vue?vue&type=script&lang=js&"
import style0 from "./visorpdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports